module.exports = ".datatable-body {\n  height: 30vh !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/search-invoices/search-invoices.component.scss
// module id = ./src/app/pages/search-invoices/search-invoices.component.scss
// module chunks = main